import React from 'react';

import { Box } from '@mui/material';
import PropTypes from 'prop-types';

import { STEP_NODE_STATUS } from '../PathToSubmission.constants';
import StepNode from '../StepNode';

import { railStyles } from './SubmissionStepper.styles';

const SubmissionStepper = ({ railSteps, onStepClick }) => (
  <Box sx={railStyles}>
    {railSteps.map((step, index) => (
      <StepNode
        index={step.index}
        isConnectorDone={index > 0 && railSteps[index - 1].nodeStatus === STEP_NODE_STATUS.DONE}
        isFirst={index === 0}
        key={step.key}
        label={step.label}
        nodeStatus={step.nodeStatus}
        stepKey={step.key}
        onSelect={onStepClick}
      />
    ))}
  </Box>
);

SubmissionStepper.propTypes = {
  railSteps: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      index: PropTypes.number.isRequired,
      nodeStatus: PropTypes.string.isRequired,
    }),
  ).isRequired,
  onStepClick: PropTypes.func.isRequired,
};

export default SubmissionStepper;
